import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSetupWizard } from './SetupWizardProvider';
import './SetupWizard.css';

const SetupWizardSidebar = ({ currentStep, totalSteps, completedSteps, validationErrors }) => {
  const { t } = useTranslation('setup');
  const { isStepCompleted, hasValidationErrors } = useSetupWizard();

  const getStepStatus = (stepNumber) => {
    if (stepNumber === currentStep) return 'current';
    if (isStepCompleted(stepNumber)) return 'completed';
    if (hasValidationErrors(stepNumber)) return 'error';
    return 'pending';
  };

  const getStepIcon = (stepNumber) => {
    const status = getStepStatus(stepNumber);
    switch (status) {
      case 'completed':
        return '✅';
      case 'current':
        return '🔄';
      case 'error':
        return '⚠️';
      default:
        return '⏳';
    }
  };

  const stepPhases = {
    1: 'foundation',
    2: 'foundation',
    3: 'foundation',
    4: 'ipcFoundation',
    5: 'ipcFoundation',
    6: 'ipcFoundation',
    7: 'protocolsAndRisks',
    8: 'protocolsAndRisks',
    9: 'operations',
    10: 'operations',
    11: 'operations',
    12: 'review',
    13: 'review'
  };

  return (
    <div className="setup-wizard-sidebar">
      <div className="sidebar-header">
        <h3>{t('sidebar.progressTitle')}</h3>
      </div>
      
      <div className="sidebar-checklist">
        {Array.from({ length: totalSteps }, (_, i) => i + 1).map(stepNumber => {
          const status = getStepStatus(stepNumber);
          const phaseKey = stepPhases[stepNumber];
          const isPhaseHeader = stepNumber === 1 || stepPhases[stepNumber - 1] !== phaseKey;
          
          return (
            <React.Fragment key={stepNumber}>
              {isPhaseHeader && (
                <div className="phase-header">
                  {t(`sidebar.phases.${phaseKey}`)}
                </div>
              )}
              <div 
                className={`checklist-item ${status}`}
                title={t(`sidebar.stepNames.${stepNumber}`)}
              >
                <span className="checklist-icon">{getStepIcon(stepNumber)}</span>
                <span className="checklist-label">
                  {stepNumber}. {t(`sidebar.stepNames.${stepNumber}`)}
                </span>
              </div>
            </React.Fragment>
          );
        })}
      </div>
      
      <div className="sidebar-tips">
        <h4>{t('sidebar.tipsTitle')}</h4>
        <div className="tip-content">
          {currentStep === 1 && (
            <p>{t('sidebar.tips.step1')}</p>
          )}
          {currentStep === 2 && (
            <p>{t('sidebar.tips.step2')}</p>
          )}
          {currentStep === 3 && (
            <p>{t('sidebar.tips.step3')}</p>
          )}
          {currentStep >= 4 && currentStep <= 6 && (
            <p>{t('sidebar.tips.step4to6')}</p>
          )}
          {currentStep >= 7 && currentStep <= 8 && (
            <p>{t('sidebar.tips.step7to8')}</p>
          )}
          {currentStep >= 9 && currentStep <= 11 && (
            <p>{t('sidebar.tips.step9to11')}</p>
          )}
          {currentStep === 12 && (
            <p>{t('sidebar.tips.step12')}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SetupWizardSidebar;
